<template>
  <q-dialog v-model="opened" no-esc-dismiss no-backdrop-dismiss>
    <q-card>
      <q-toolbar>
        <q-toolbar-title>
          The content you're working on just changed!
        </q-toolbar-title>
      </q-toolbar>

      <q-toolbar style="width: 50%; display: inline-block;">
        <q-toolbar-title>
          Your Version
        </q-toolbar-title>
      </q-toolbar>

      <q-toolbar style="width: 50%; display: inline-block; float: right;">
        <q-toolbar-title>
          Their Version
        </q-toolbar-title>
      </q-toolbar>

<!--      <ace-editor-->
<!--        v-if="opened"-->
<!--        :content="yours"-->
<!--        :sync="true"-->
<!--        :options="aceOpts"-->
<!--        :readOnly="true"-->
<!--        @scrollV="scrollHandler(editor, ...arguments)">-->
<!--      </ace-editor>-->
<!--      <ace-editor-->
<!--        v-if="opened"-->
<!--        :content="theirs"-->
<!--        :sync="true"-->
<!--        :options="aceOpts"-->
<!--        :readOnly="true"-->
<!--        @scrollV="scrollHandler(editor, ...arguments)">-->
<!--      </ace-editor>-->
      <!--<codemirror ref="cmDiff" :merge="true" :options="cmOptions" @scroll="onCmScroll" style="width: 50vw" v-if="opened"></codemirror>-->
      <q-btn @click="useYours" class="q-ma-sm" flat color="primary">Use Your Version</q-btn>
      <q-btn @click="useTheirs" class="float-right q-ma-sm" flat color="primary">Use Their Version</q-btn>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  data () {
    return {
      theirs: '',
      yours: '',
      aceOpts: {
        theme: 'monokai'
      },
      cmOptions: {
        value: '',
        origRight: null,
        // orig: '',
        connect: 'align',
        mode: 'text/x-markdown',
        showLineNumbers: false,
        collapseIdentical: false,
        showDifferences: true,
        readOnly: true,
        revertButtons: false
      },
      name: '',
      opened: false,
      responsePromise: null,
      resolvePromise: null,
      rejectPromise: null,
      remoteObj: ''
    }
  },
  methods: {
    show (localObj, remoteObj) {
      this.opened = true
      this.yours = localObj
      this.theirs = remoteObj
      // this.cmOptions.origRight = null
      let t = this
      this.responsePromise = new Promise((resolve, reject) => {
        t.resolvePromise = resolve
        t.rejectPromise = reject
      })

      this.$nextTick(() => {
        // this.$nextTick(() => {
        //   t.$refs['cmDiff'].refresh()
        // })
      })
      return this.responsePromise
    },

    onCmScroll () {

    },

    useYours () {
      this.rejectPromise()
      this.opened = false
    },

    useTheirs () {
      this.resolvePromise(this.theirs)
      this.opened = false
    }
  },
  mounted () {
    // let items = [1, 2, 3, 4, 5, 6]
    // items.forEach(i => {
    //   this.myArray.push({
    //     name: i,
    //     id: i
    //   })
    // })
  }
}
</script>

<style>
</style>
